import { APIURL } from "./config";
import { Interviewer, InterviewSlots } from "../Models";


export const GetInterviewSlots = async (
    roleId: string | null | undefined = null,
    token: string
) => {
    const url = roleId
        ? `${APIURL}/Roles/interviewSlots?roleId=${roleId}`
        : `${APIURL}/Roles/interviewSlots`;
    const res = await fetch(`${url}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    const slots: InterviewSlots[] = await res.json();
    return slots;
};


export const getAssessmentVersions = async () => {
    try {
        const res = await fetch(`${APIURL}/MasterData/assessment-versions`);
        if (!res.ok) {
            // Endpoint not found or error - use defaults
            return [
                { id: 1, name: "Version 1 - Batch Submission" },
                { id: 2, name: "Version 2 - Sequential Submission" },
            ];
        }
        const data = await res.json();
        return data;
    } catch (error) {
        // Network error - use defaults silently
        return [
            { id: 1, name: "Version 1 - Batch Submission" },
            { id: 2, name: "Version 2 - Sequential Submission" },
        ];
    }
};

export const chooseSlot = async (
    candidateId: string | undefined,
    slotId: string,
    roleStatusId: string | undefined,
) => {
    try {
        var request = {
            candidateId,
            slotId,
            roleStatusId,
        };
        const response = await fetch(`${APIURL}/Candidates/chooseSlot`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(request),
        });

        var res: { type: "success" | "error" | "info"; description: string } = {
            type: "success",
            description: "",
        };
        if (!response.ok) {
            const errorData = await response.json();
            res = {
                type: "error",
                description: errorData.message,
            };
            return res;
        } else {
            res = {
                type: "success",
                description: "Slot Booked Successfully.",
            };
            return res;
        }
    } catch (error) {
        res = {
            type: "error",
            description: "Something went wrong,Please try again.",
        };
        return res;
    }
};


